<template>
  <label
    :class="[
      'ep-checkbox__label',
      classes
    ]"
  >
    <v-row class="pa-0 ma-0">
      <input
        type="checkbox"
        class="ep-checkbox__input"
        :checked="modelValue"
        :disabled="disabled"
        @input="$emit('update:model-value', $event.target.checked)"
      >

      <span class="ep-checkbox__checkmark"></span>

      <p
        v-if="label"
        class="subtitle ma-0 pl-2"
      >
        {{ label }}
      </p>
    </v-row>
  </label>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    classes: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/components/_checkbox";
</style>
